import React from "react"
import { Box, styled } from "@mui/material"
import { CacheProvider } from "@emotion/react"
import { ltrCache } from "utils/theme"

interface NonRTLWrapperProps {
  children: React.ReactNode
}

// This component is used to wrap children components to force Left to Right (LTR) rendering.
const LeftToRightBox = styled(Box)({
  direction: "ltr",
  width: "100%",
  height: "100%",
  "& *": {
    direction: "ltr",
  },
})

export const LeftToRightWrapper: React.FC<NonRTLWrapperProps> = ({
  children,
}) => {
  return (
    <CacheProvider value={ltrCache}>
      <LeftToRightBox dir="ltr">{children}</LeftToRightBox>
    </CacheProvider>
  )
}
